import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import './Layout.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ComplianceStatus from '../../pages/compliance/complianceStatus/compliance_status';
import i18n from '../../i18n';
import UserManage from 'src/pages/User/UserManage';
import Notification from '../Notification/Notification';
import DashboardImplemetor from 'src/pages/DashboardImplementor/DashboardImplemetor';
import TaskUserCalender from 'src/pages/DashboardImplementor/component/TaskUserCalender';
import RiskCatalog from 'src/pages/Risk/RiskCatalog';
import CreateRiskForm from 'src/pages/Risk/CreateRisk/Create';
import UpdateRiskForm from 'src/pages/Risk/UpdateRisk/update';
import Assessment from 'src/pages/Risk/assessment/Assessment';
import AnnouncementTable from 'src/pages/Announcement/announcement';

import Rcsa from 'src/pages/RCSA/rcsa';
import CertificationsList from 'src/pages/certifications/ListCertifications';
import CreateQuestion from 'src/pages/SurveyQuestion/BankQuestions/CreateQuestion';
import CreateSurvey from 'src/pages/SurveyQuestion/Surveys/CreateSurvey';
import Surveys from 'src/pages/SurveyQuestion/Surveys/Surveys';
import QuestionTable from 'src/pages/SurveyQuestion/BankQuestions/questionCatalog';
import ExportSurvey from 'src/pages/SurveyQuestion/Surveys/ExportSurvey';
import UpdateSurvey from 'src/pages/AllSurveys/UpdateSurvey';
import UpdateQuestion from 'src/pages/SurveyQuestion/BankQuestions/UpdateQuestion';
import PermissionPages from 'src/pages/PermissionLoginPages/PermissionPages';
import ImpactAreaTable from 'src/pages/ImpactArea/ViewImpact';
import CreateImpact from 'src/pages/ImpactArea/CreateImpact';
import UpdateImpact from 'src/pages/ImpactArea/update/updateImpact';
import Register from 'src/pages/register/Register';
import CreateFunctionPage from 'src/pages/FunctionUser/Function';
import SurvyQuestionTable from 'src/pages/AllSurveys/Surveys';
import ReplayQuestion from 'src/pages/AllSurveys/ReplayQuestion';
import QuestionControlTree from 'src/pages/QuestionControl/QuestionControlTree';
import TeamOnboarding from 'src/pages/invitationUser/inviteTeam';
import ObjectiveModal from 'src/pages/Objective/objectiveModal';
import UnifiedControlLandscape from 'src/pages/frameWork/frameWork';
import AssessmentScore from 'src/pages/frameWork/AssessmentScore';
import ProtectedRoute from '../ProtectedRoute';
import OrganizationChart from 'src/pages/OrganizationChart/OrganizationChart';
import FileManager from 'src/pages/OnBoxMessage/viewAllMessage';
import RoleBasedRoute from '../RoleBasedRoute';
import UpdateControlPage from 'src/pages/referenes/updateControl';
import SubscriptionAlert from '../SubscriptionAlert';
import AssetsList from 'src/pages/AssetsManagement/AssetsList';
import CreateAsset from 'src/pages/AssetsManagement/CreateAsset';
import AssetDetails from 'src/pages/AssetsManagement/AssetDetails';
import EditAsset from 'src/pages/AssetsManagement/EditAsset';
import DataSourceList from 'src/pages/dataresource/index';
import DataSourceDetails from 'src/pages/dataresource/DataSourceDetails';
import UpdateDataSource from 'src/pages/dataresource/update/UpdateDataSource';
import DocumentList from 'src/pages/DocumentManagement/DocumentList';
import DocumentUpload from 'src/pages/DocumentManagement/DocumentUpload';
import DocumentDetails from 'src/pages/DocumentManagement/DocumentDetails';
import DocumentEdit from 'src/pages/DocumentManagement/DocumentEdit';
import ComplianceDashboard from 'src/pages/DocumentManagement/ComplianceDashboard';

import FileStructure from 'src/pages/DocumentManagement/FileStructure';
import DemoPartners from 'src/pages/demo/DemoPartners';
import DemoPartnerQuestionnaires from 'src/pages/demo/DemoPartnerQuestionnaires';
import DemoPartnerDocuments from 'src/pages/demo/DemoPartnerDocuments';
import DemoPartnerStatus from 'src/pages/demo/DemoPartnerStatus';
import DemoPartnerTickets from 'src/pages/demo/DemoPartnerTickets';
import DemoPartnerCertifications from 'src/pages/demo/DemoPartnerCertifications';
import DemoPartnerAssessmentRequests from 'src/pages/demo/DemoPartnerAssessmentRequests';
import DemoPartnerProfile from 'src/pages/demo/DemoPartnerProfile';
import DemoPartnerVisibility from 'src/pages/demo/DemoPartnerVisibility';


const ViewControl = React.lazy(() => import('../../pages/compliance/assessment/viewControl'));
const CreateCompliance = React.lazy(() => import('../../pages/compliance/createCompliance/CreateCompliance'));
const UpdateCompliance = React.lazy(() => import('../../pages/compliance/editCompliance/UpdateCompliance'));
const Compliance = React.lazy(() => import('../../pages/compliance/compliance/Compliance'));
const InformationCompliance = React.lazy(() => import('../../pages/compliance/info/informationCompliance'));
const Dashboard = React.lazy(() => import('../../pages/dashboard/Dashboard'));
const References = React.lazy(() => import('../../pages/referenes/references'));
const Login = React.lazy(() => import('../../pages/login/login'));

const Tickets = React.lazy(() => import('../../pages/Tickets/Tickets'));
const SubscriptionPage = React.lazy(() => import('../../pages/subscription/SubscriptionPage'));
const RenewSubscriptionPage = React.lazy(() => import('../../pages/renew-subscription/RenewSubscriptionPage'));




const Main: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const location = useLocation();
    
    // Example: Set direction dynamically
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Determine if the current route is the login/register page
    // Note: pathname is relative to basename, so '/login' is correct
    // Also handle legacy '/compliance/login' URL by treating it as login
    const isLoginPage =
      location.pathname === '/login' ||
      location.pathname === '/register' ||
      location.pathname === '/compliance/login';

    const updateDirection = (lng: string) => {
        // Implement your direction update logic here
        //console.log(`Direction updated for language: ${lng}`);
    };

    const handleLanguageChange = (lng: string) => {
        updateDirection(lng);
    };

    useEffect(() => {
        i18n.on('languageChanged', handleLanguageChange);

        // Cleanup listener on component unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);
//console.log(userRole,"userRoleuserRoleuserRole")
    return (
        <div className={`layout ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            {!isLoginPage &&  <Sidebar 
              isOpen={isSidebarOpen} 
              onToggle={() => setIsSidebarOpen(!isSidebarOpen)} 
              language={i18n.language as 'en' | 'ar'} 
            />}
            <div className={`${!isLoginPage ? 'main-content' : 'main-content-login w-100'}`}>
                <ToastContainer />
                {!isLoginPage && (
                  <>
                    <SubscriptionAlert />
                    <Header onMobileToggle={toggleSidebar}  className='w-100 z-100' />
                  </>
                )}
                <React.Suspense fallback={
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }>
                    <Routes>
              
                    <Route path="/" element={
                          <ProtectedRoute>
                            <RoleBasedRoute />
                          </ProtectedRoute>
                        } />
                        <Route path="/info" element={
                          <ProtectedRoute>
                            <InformationCompliance />
                          </ProtectedRoute>
                        } />
                         <Route path="/announcements" element={
                          <ProtectedRoute>
                            <AnnouncementTable/>
                          </ProtectedRoute>
                        } />
                        <Route path="/compliances" element={
                          <ProtectedRoute>
                            <Compliance />
                          </ProtectedRoute>
                        } />
                        <Route path="/standards" element={
                          <ProtectedRoute>
                            <References />
                          </ProtectedRoute>
                        } />
                        <Route path="/compliance-status" element={
                          <ProtectedRoute>
                            <ComplianceStatus />
                          </ProtectedRoute>
                        } />
                        <Route path="/ticket" element={
                          <ProtectedRoute>
                            <Tickets />
                          </ProtectedRoute>
                        } />
    <Route path="/organization-chart" element={
                          <ProtectedRoute>
                            <OrganizationChart/>
                          </ProtectedRoute>
                        } /> 

                          <Route path="/oneboxMessage" element={
                          <ProtectedRoute>
                           <FileManager />
                          </ProtectedRoute>
                        } />
                        <Route path="/create" element={
                          <ProtectedRoute>
                            <CreateCompliance />
                          </ProtectedRoute>
                        } />
                        <Route path="/compliances/edit/:id" element={
                          <ProtectedRoute>
                            <UpdateCompliance />
                          </ProtectedRoute>
                        } />
                        <Route path="/certifications" element={
                          <ProtectedRoute>
                            <CertificationsList/>
                          </ProtectedRoute>
                        } />

                        <Route path="/compliances/status/:id" element={
                          <ProtectedRoute>
                            <ComplianceStatus/>
                          </ProtectedRoute>
                        } />
                        <Route path="/compliances/view-control/:id/:fieldId/:subFieldId" element={
                          <ProtectedRoute>
                            <ViewControl />
                          </ProtectedRoute>
                        } />
                        <Route path="/login" element={<Login />} />
                        {/* Legacy /compliance/login URL: redirect to canonical /login */}
                        <Route path="/compliance/login" element={<Navigate to="/login" replace />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/demo-partners" element={
                          <ProtectedRoute>
                            <DemoPartners />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/questionnaires" element={
                          <ProtectedRoute>
                            <DemoPartnerQuestionnaires />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/documents" element={
                          <ProtectedRoute>
                            <DemoPartnerDocuments />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/status" element={
                          <ProtectedRoute>
                            <DemoPartnerStatus />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/tickets" element={
                          <ProtectedRoute>
                            <DemoPartnerTickets />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/certifications" element={
                          <ProtectedRoute>
                            <DemoPartnerCertifications />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/assessment-requests" element={
                          <ProtectedRoute>
                            <DemoPartnerAssessmentRequests />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/profile" element={
                          <ProtectedRoute>
                            <DemoPartnerProfile />
                          </ProtectedRoute>
                        } />
                        <Route path="/demo-partner/visibility" element={
                          <ProtectedRoute>
                            <DemoPartnerVisibility />
                          </ProtectedRoute>
                        } />
                        <Route path="/function" element={
                          <ProtectedRoute>
                            <CreateFunctionPage/>
                          </ProtectedRoute>
                        } />
                        <Route path="/QuestionControlTree" element={
                          <ProtectedRoute>
                            <QuestionControlTree/>
                          </ProtectedRoute>
                        } />
                        <Route path="/createsurvey" element={
                          <ProtectedRoute>
                            <CreateSurvey/>
                          </ProtectedRoute>
                        } /> 

                   <Route path="/viewsurvey" element={
                     <ProtectedRoute>
                       <SurvyQuestionTable/>
                     </ProtectedRoute>
                   } /> 
                      <Route path="/updatesurvey/:id" element={
                        <ProtectedRoute>
                          <UpdateSurvey/>
                        </ProtectedRoute>
                      } />
                        <Route path="/user" element={
                          <ProtectedRoute>
                            <UserManage/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/notification" element={
                          <ProtectedRoute>
                            <Notification/>
                          </ProtectedRoute>
                        } /> 
           <Route path="/team-onboarding" element={
             <ProtectedRoute>
               <TeamOnboarding />
             </ProtectedRoute>
           } />

                        <Route path="/exportsurvey/:id" element={
                          <ProtectedRoute>
                            <ExportSurvey/>
                          </ProtectedRoute>
                        } /> 
                        {/* Survey assessment (new and legacy paths) */}
                        <Route path="/assessmentsurvey/:id" element={
                          <ProtectedRoute>
                            <ReplayQuestion/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/assessment-survey/:id" element={
                          <ProtectedRoute>
                            <ReplayQuestion/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/objective" element={
                          <ProtectedRoute>
                            <ObjectiveModal/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/frameWork" element={
                          <ProtectedRoute>
                            <UnifiedControlLandscape/>
                          </ProtectedRoute>
                        } />
                        <Route path="/assessment-score" element={
                          <ProtectedRoute>
                            <AssessmentScore/>
                          </ProtectedRoute>
                        } /> 

                     
                       <Route path="/updatecontrol/:id" element={
                            // <ProtectedRoute>
                             <UpdateControlPage/>
                            // </ProtectedRoute>
                        } /> 

                        <Route path="/viewTaskCalender" element={
                          <ProtectedRoute>
                            <TaskUserCalender/>
                          </ProtectedRoute>
                        } /> 
                        {/* Risk & RCSA routes */}
                        <Route path="/assessment/:id" element={
                          <ProtectedRoute>
                            <Assessment/>
                          </ProtectedRoute>
                        } />
                        <Route path="/rcsa" element={
                          <ProtectedRoute>
                            <Rcsa/>
                          </ProtectedRoute>
                        } />
                        <Route path="/permission" element={
                          <ProtectedRoute>
                            <PermissionPages/>
                          </ProtectedRoute>
                        } />
                        <Route path="/subscription" element={
                          <ProtectedRoute>
                            <SubscriptionPage/>
                          </ProtectedRoute>
                        } />
                        <Route path="/renew-subscription" element={
                          <ProtectedRoute>
                            <RenewSubscriptionPage/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/assets" element={
                          <ProtectedRoute>
                            <AssetsList />
                          </ProtectedRoute>
                        } />
                        <Route path="/assets/create" element={
                          <ProtectedRoute>
                            <CreateAsset />
                          </ProtectedRoute>
                        } />
                        <Route path="/assets/:id" element={
                          <ProtectedRoute>
                            <AssetDetails />
                          </ProtectedRoute>
                        } />
                        <Route path="/assets/edit/:id" element={
                          <ProtectedRoute>
                            <EditAsset />
                          </ProtectedRoute>
                        } />
                        <Route path="/dataresource" element={
                          <ProtectedRoute>
                            <DataSourceList />
                          </ProtectedRoute>
                        } />
                        <Route path="/dataresource/:id" element={
                          <ProtectedRoute>
                            <DataSourceDetails />
                          </ProtectedRoute>
                        } />
                        <Route path="/dataresource/update/:id" element={
                          <ProtectedRoute>
                            <UpdateDataSource />
                          </ProtectedRoute>
                        } />
                        {/* Document Management Routes */}
                        <Route path="/documents" element={
                          <ProtectedRoute>
                            <DocumentList />
                          </ProtectedRoute>
                        } />
                        <Route path="/documents/upload" element={
                          <ProtectedRoute>
                            <DocumentUpload />
                          </ProtectedRoute>
                        } />
                        <Route path="/documents/:id/edit" element={
                          <ProtectedRoute>
                            <DocumentEdit />
                          </ProtectedRoute>
                        } />
                        <Route path="/documents/:id" element={
                          <ProtectedRoute>
                            <DocumentDetails />
                          </ProtectedRoute>
                        } />
                        <Route path="/documents/dashboard" element={
                          <ProtectedRoute>
                            <ComplianceDashboard />
                          </ProtectedRoute>
                        } />
                        <Route path="/documents/notifications" element={
                          <ProtectedRoute>
                            <Notification />
                          </ProtectedRoute>
                        } />
                        <Route path="/documents/structure" element={
                          <ProtectedRoute>
                            <FileStructure />
                          </ProtectedRoute>
                        } />
                        {/*<Route path="/impactArea" element={<ImpactAreaTable/>} /> 
                        <Route path="/createImpact" element={<CreateImpact/>} /> 
                        <Route path="/updateImpacted/:id" element={<UpdateImpact/>} /> 


                        <Route path="/assessment-survey/:id" element={<ReplayQuestion/>} /> 
                        <Route path="/updateSurvey/:id" element={<UpdateSurvey/>} /> */}
                        
                        {/* Survey Routes */}
                        <Route path="/create-survey" element={
                          <ProtectedRoute>
                            <CreateSurvey/>
                          </ProtectedRoute>
                        } />
                        <Route path="/export-survey/:id" element={
                          <ProtectedRoute>
                            <ExportSurvey/>
                          </ProtectedRoute>
                        } />
                        <Route path="/surveys" element={
                          <ProtectedRoute>
                            <Surveys/>
                          </ProtectedRoute>
                        } />
                        <Route path="/bankQuestions" element={
                          <ProtectedRoute>
                            <QuestionTable/>
                          </ProtectedRoute>
                        } />
                        <Route path="/createQuestion" element={
                          <ProtectedRoute>
                            <CreateQuestion/>
                          </ProtectedRoute>
                        } />
                        <Route path="/updateQuestion/:id" element={
                          <ProtectedRoute>
                            <UpdateQuestion/>
                          </ProtectedRoute>
                        } />
                        
                        {/* Survey Routes */}
                        <Route path="/create-survey" element={
                          <ProtectedRoute>
                            <CreateSurvey/>
                          </ProtectedRoute>
                        } />
                        <Route path="/export-survey/:id" element={
                          <ProtectedRoute>
                            <ExportSurvey/>
                          </ProtectedRoute>
                        } />
                        <Route path="/surveys" element={
                          <ProtectedRoute>
                            <Surveys/>
                          </ProtectedRoute>
                        } />
                        <Route path="/bankQuestions" element={
                          <ProtectedRoute>
                            <QuestionTable/>
                          </ProtectedRoute>
                        } />
                        <Route path="/createQuestion" element={
                          <ProtectedRoute>
                            <CreateQuestion/>
                          </ProtectedRoute>
                        } />
                        <Route path="/updateQuestion/:id" element={
                          <ProtectedRoute>
                            <UpdateQuestion/>
                          </ProtectedRoute>
                        } />

                        

                    </Routes>
                </React.Suspense>
            </div>
        </div>
    );
};

export default Main;















